<template>
  <div class="icon-jifens" :class="[size ? size : '']">
    <i class="icons icon-jifen-v"></i>{{points}}<span>{{  text == 'no' ? '' : '积分' }}</span>
  </div>
</template>
<script>
export default {
  name: "IconJifen",
  props: {
    points: {
      type: Number,
      default: 0
    },
    size: String,
    text: String
  }
};
</script>
<style scoped>
.icon-jifens {
  font-size: 20px;
  color: #ffcc00;
  font-family: Arial, Helvetica, sans-serif;
  display: inline-block;
}
.icon-jifens span {
  margin-left: 3px;
  font-size: 18px;
  vertical-align: 1px;
}
.icon-jifen-v {
  background-position: 0 -96px;
  display: inline-block;
  width: 22px;
  height: 22px;
  cursor: pointer;
  vertical-align: -4px;
  margin-right: 2px;
}

.mini .icon-jifen-v {
  background-position: 0 -173px;
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  vertical-align: -5px;
  margin-right: 3px;
}
.mini {
  font-size: 14px;
  color: #FF7300;
}
.mini span {
  font-size: 14px;
  vertical-align: 0;
}

.gray .icon-jifen-v {
  background-position: -19px -33px;
  display: inline-block;
  width: 18px;
  height: 18px;
  cursor: pointer;
  vertical-align: -4px;
  margin-right: 4px;
}
.gray {
  font-size: 12px;
  color: #111;
}
.gray span {
  font-size: 12px;
  vertical-align: 0;
  color: #666;
}
</style>
